<script>
import Users from '../user/list'
export default {
  props: {
    user: Object
  },
  components: {
    Users
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
};
</script>

<template>
  <div>
    <Users :parent="user" :search-by-parent="true" />
  </div>
</template>
